import { createContext } from 'react';

type PremiumBuyerSubscriptionProps = {
  recaptchaRef: React.MutableRefObject<any>;
};

export default createContext<Partial<PremiumBuyerSubscriptionProps>>({
  recaptchaRef: null,
});
